import React, {Component} from 'react';
import { Row } from 'react-materialize'
import 'rc-slider/assets/index.css';
import Slider from 'rc-slider';
import Tooltip from 'rc-tooltip';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


const Handle = Slider.Handle;
const createSliderWithTooltip = Slider.createSliderWithTooltip;
const Range = Slider.Range;



const handle = (props) => {
  const { value, dragging, index, ...restProps } = props;
  return (
    <Tooltip
      prefixCls="rc-slider-tooltip"
      overlay={value}
      visible={dragging}
      placement="bottom"
      key={index}
    >
      <Handle value={value} {...restProps} />
    </Tooltip>
  );
};


class YearSlider extends Component {
  constructor(props){
    super(props);
    this.state = {
      toolTip: true
    }
  }


    render() {
      const { onChangeYear = ()  => {}, onCloseYearToolTip = () => {} } = this.props;
      const { yearMin, yearMax, yearBound, yearToolTip } = this.props;
      const { toolTip } = this.state;
      return (
        <Row>
          <div>
            <Range
              defaultValue={yearBound}
              min={yearMin}
              max={yearMax}
              // marks={marks}
              step={1}
              tipFormatter={value => `${value}`}
              handle={handle}
              allowCross={false}
              onChange={(val)=> onChangeYear(val)} />
          </div>
          <div style={{display: "flex", justifyContent:"space-between"}}>
            <span>{yearMin}</span>
            <span>{yearMax}</span>
          </div>
          {
            yearToolTip?
            (
              <div>
                <div className="tool-tip">
                  <div className="tooltip-text">
                    <div style={{fontWeight: 'bold', display:'flex', justifyContent: 'space-between', alignSelf: 'center'}}>
                        <span>TIP</span>
                        <span style={{ cursor: 'pointer'}} onClick={onCloseYearToolTip}>x</span>
                    </div>
                    <span>Use the slide bar to limit the data to a specific year range.</span>
                    </div>
                  </div>
                </div>
              ):""
            }
          </Row>
        );
    }
  }


  function mapStateToProps(state){
    return {
      yearBound: state.yearBound,
      yearMax: state.yearMax,
      yearMin: state.yearMin,
      yearToolTip: state.yearToolTip
    }
  };

  function mapDispatchToProps(dispatch){
    return {
      onChangeYear: (val) => dispatch({ type: 'ONCHANGEYEAR', value: val }),
      onCloseYearToolTip: ()=> dispatch({ type: 'ONCLOSEYEARTOOLTIP'})
    }
  }

  export default connect(mapStateToProps, mapDispatchToProps)(YearSlider);

// export default YearSlider;



// WEBPACK FOOTER //
// ./src/components/YearSlider.js